import React, { useState } from "react";

import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { Tooltip } from "@mui/material";

import { Access } from "../../../consts/access";
import { UserRole } from "../../../consts/user-role";
import { useAuth } from "../../../hooks/useAuth";
import { useModal } from "../../../hooks/useModal";
import { CafsTreeNodeType } from "../../../types/cafs-tree-node-type";

import { MoveCafsModal } from "./MoveCafsModal";

type CafsMoveProps = {
  node: CafsTreeNodeType;
  allCafsNodes: CafsTreeNodeType[];
};

export function CafsMove({ node, allCafsNodes }: CafsMoveProps) {
  const [cafsToMove, setCafsToMove] = useState<CafsTreeNodeType>();
  const { open, handleOpen, handleClose } = useModal();
  const { user } = useAuth();

  const shouldRender =
    node.access === Access.Full &&
    (user?.Role === UserRole.FarmTreeMaster ||
      user?.Role === UserRole.FarmTreeDeveloper);

  const handleCafsMove = (node: CafsTreeNodeType) => {
    setCafsToMove(node);
    handleOpen();
  };

  return shouldRender ? (
    <>
      <Tooltip title="Move this CAFS to a different parent">
        <div>
          <AccountTreeOutlinedIcon
            className="text-primary hover:text-green-600 text-xl cursor-pointer"
            onClick={() => handleCafsMove(node)}
          />
        </div>
      </Tooltip>
      <MoveCafsModal
        open={open}
        onClose={handleClose}
        cafs={cafsToMove}
        allCafsNodes={allCafsNodes}
      />
    </>
  ) : null;
}
